<template>
  <div class="tour-gallery-thumb-wrapper">
    <img width="200" height="200"
      class="thumb-image lazyload"
      :class="{selected: selected}"
      :alt="image.description" 
      :data-src="getContentfulImgURL({
        url: image.url,
        width: 260,
        height: 180,
        quality: 90
      })">
  </div>
</template>
<script>
import imageOptimo from "~/mixins/imageOptimoMixin.js";

export default {
  name: "TourGalleryThumbnail",
  mixins: [imageOptimo],
  props: {
    image: {
      type: Object,
      required: true
    },
    selected: Boolean
  }
};
</script>

<style lang="scss" scoped>
.tour-gallery-thumb-wrapper {
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  background: #ebeef1;
  height: 100%;
  width: 100%;
  // margin-right: 8px;
  -o-object-fit: cover;
  object-fit: cover;
  flex-shrink: 0;

  img.thumb-image {
    // position: absolute;
    top: 0;
    object-position: center center;
    height: 100%;
    object-fit: cover;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    opacity: 0.5;
    &.selected {
      opacity: 1;
    }
  }
}
</style>
